module.exports = __webpack_public_path__ + "media/edvisors/edvisors-logo-white-eed53061.svg";